export default __webpack_public_path__ + "static/media/star-score-filled.5dbffe09.svg";